"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _bytes = require("bytes");

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _DownloadIcon = _interopRequireDefault(require("./Assets/DownloadIcon"));

var _Localize = require("../Localization/Localize");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = (0, _connectToWebChat.default)(function (_ref) {
  var language = _ref.language,
      styleSet = _ref.styleSet;
  return {
    language: language,
    styleSet: styleSet
  };
})(function (_ref2) {
  var _ref2$activity = _ref2.activity,
      _ref2$activity$attach = _ref2$activity.attachments,
      attachments = _ref2$activity$attach === void 0 ? [] : _ref2$activity$attach,
      _ref2$activity$channe = _ref2$activity.channelData;
  _ref2$activity$channe = _ref2$activity$channe === void 0 ? {} : _ref2$activity$channe;
  var _ref2$activity$channe2 = _ref2$activity$channe.attachmentSizes,
      attachmentSizes = _ref2$activity$channe2 === void 0 ? [] : _ref2$activity$channe2,
      attachment = _ref2.attachment,
      language = _ref2.language,
      styleSet = _ref2.styleSet;
  var attachmentIndex = attachments.indexOf(attachment);
  var label = (0, _Localize.localize)('Download file', language);
  var size = attachmentSizes[attachmentIndex];
  return _react.default.createElement("div", {
    className: styleSet.downloadAttachment
  }, _react.default.createElement("a", {
    href: attachment.contentUrl,
    target: "_blank"
  }, _react.default.createElement("div", {
    className: "details"
  }, _react.default.createElement("div", {
    className: "name"
  }, attachment.name), typeof size === 'number' && _react.default.createElement("div", {
    className: "size"
  }, (0, _bytes.format)(size))), _react.default.createElement(_DownloadIcon.default, {
    className: "icon",
    label: label,
    size: 1.5
  })));
});

exports.default = _default;